export const SOCKET_URL = process.env.NODE_ENV === "development" ? "http://localhost:8080/maze-runner-game" : "/maze-runner-game";
